import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Extraer la llamada al backend (service)
export const registerUser = (data) => {
    return axios.post(API_ROUTES.REGISTER, data);
};